
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/near-me/hub",
      function () {
        return require("private-next-pages/near-me/hub.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/near-me/hub"])
      });
    }
  